import React, { Fragment } from "react";
import { Formik } from "formik";
import Select from "react-select";
import PageTitle from "../../../layouts/PageTitle";
import { create, updateAction } from "../../../../store/actions/CommonActions";
import CustomTextarea from "../../../components/Forms/CustomInputs/CustomTextarea";
import { notificationValidationSchema } from "../../../../utils/validationSchemas/MasterDataSchema";
import CustomDropdown from "../../../components/Forms/CustomInputs/CustomDropdown";
import { useSelector } from "react-redux";
import CustomImageUpload from "../../../components/Forms/CustomInputs/CustomImageUpload";
import CustomTextbox from "../../../components/Forms/CustomInputs/CustomTextbox";

const ConfigNotificationsUi = ({
    initialValues,
    handleFormSubmit,
}) => {
    return (
        <Fragment>

            <div className="row container-mxw">
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header d-block">
                            <h4 className="card-title">
                                Push Notifications
                            </h4>
                            <p>Send, schedule, and manage app notifications for your users.</p>
                        </div>
                        <div className="card-body">
                            <div className="basic-form">
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={notificationValidationSchema}
                                    onSubmit={handleFormSubmit}
                                >
                                    {({
                                        values,
                                        errors,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                        isSubmitting,
                                        setFieldValue,
                                    }) => (
                                        <form onSubmit={handleSubmit}>
                                            <div className="row">
                                                <CustomTextbox
                                                    fieldName="title"
                                                    value={values.title}
                                                    error={errors.title}
                                                    label={"Notification Title"}
                                                    classes={"col-md-12"}
                                                    handleBlur={handleBlur}
                                                    inputType={"text"}
                                                    handleChange={handleChange}
                                                />
                                                <CustomTextarea
                                                    errors={errors}
                                                    setFieldValue={setFieldValue}
                                                    handleBlur={handleBlur}
                                                    values={values}
                                                    fieldName={"message"}
                                                    title={"Message"}
                                                />
                                                <div className="custom-checkbox mb-3 col-md-12">
                                                    <label className="text-label d-block">Select Audience</label>
                                                    <div
                                                        className={`form-group mb-3 ${errors && errors.audience ? "is-invalid" : "is-valid"
                                                            }`}
                                                    >
                                                        <Select
                                                            value={{
                                                                label: (values.audience || "Select Audience").charAt(0).toUpperCase() + (values.audience || "Select Audience").slice(1),
                                                                value: values.audience || "",
                                                            }}
                                                            onChange={(e) => {
                                                                handleChange({ target: { name: 'audience', value: e.value } })
                                                            }}
                                                            options={[{ label: 'All', value: 'all' }, { label: 'Audience', value: 'audience' }, { label: 'Group', value: 'group' }]}
                                                            name={`audience`}
                                                            style={{
                                                                color: "#7e7e7e",
                                                                paddingLeft: " 15px",
                                                            }}
                                                            classNames={{
                                                                control: (state) => "form-control p-0 select-custom-css", // add your class here
                                                            }}
                                                        />

                                                        {errors.audience && (
                                                            <div
                                                                id={`val-audience-error`}
                                                                class="invalid-feedback animated fadeInUp"
                                                                style={{ display: "block" }}
                                                            >
                                                                {errors.audience}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="float-end">
                                                <button
                                                    type="submit"
                                                    className="btn me-2 btn-primary"
                                                    disabled={isSubmitting}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                            {/* <button className="btn btn-danger light">Cancel</button> */}
                                        </form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ConfigNotificationsUi;
